
import style from './css/SharePopup.module.css';

export default function SharePopup({ showSharePopup, setShowSharePopup }) {
    return (
        <div style={{display: (showSharePopup) ? 'flex' : 'none'}} className={style.bg}>
            <div style={{display: 'inline-block'}}>
                <div onClick={() => {setShowSharePopup(false)}} className={style.closeBtn}>
                    <div style={{ position: 'relative', display: 'inline-block', width: '24px', height: '24px', cursor: 'pointer' }}>
                        <div style={{
                            position: 'absolute',
                            top: '11px',
                            left: '4px',
                            width: '25px',
                            height: '2px',
                            background: 'white',
                            transform: 'rotate(45deg)',
                        }} />
                        <div style={{
                            position: 'absolute',
                            top: '11px',
                            left: '4px',
                            width: '25px',
                            height: '2px',
                            background: 'white',
                            transform: 'rotate(-45deg)',
                        }} />
                    </div>
                </div>
                <div className={style.popup}>
                    <h3>공유하기</h3>
                    <div className={style.btnArea}>
                        <div className={style.btnItem}>
                            <div className={style.imgArea}>
                                <img src="/imgs/share_icons/share_kakao.png" alt="kakao" />
                            </div>
                            <span>카카오톡</span>
                        </div>
                        <div className={style.btnItem}>
                            <div className={style.imgArea}>
                                <img src="/imgs/share_icons/share_story.png" alt="kakaostory" />
                            </div>
                            <span>카카오스토리</span>
                        </div>
                        <div className={style.btnItem}>
                            <div className={style.imgArea}>
                                <img src="/imgs/share_icons/share_sms.png" alt="SMS" />
                            </div>
                            <span>문자</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}